import { render, staticRenderFns } from "./digital_asset_folder.vue?vue&type=template&id=6b0bc588&scoped=true&lang=pug"
import script from "./digital_asset_folder.vue?vue&type=script&lang=js"
export * from "./digital_asset_folder.vue?vue&type=script&lang=js"
import style0 from "./digital_asset_folder.vue?vue&type=style&index=0&lang=scss"
import style1 from "./digital_asset_folder.vue?vue&type=style&index=1&id=6b0bc588&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bc588",
  null
  
)

export default component.exports